import Cookies from "js-cookie";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Chats from "./AdminPanel/components/Chat/Chats";
import PrivacyPassword from "./AdminPanel/components/MyProfile/PrivacyPassword";
import AllMostSpentCustomers from "./AdminPanel/components/UsersSection/AllMostSpentCustomers";
import AllNewCustomer from "./AdminPanel/components/UsersSection/AllNewCustomer";
import AllTopCustomers from "./AdminPanel/components/UsersSection/AllTopCustomers";
import AllHightOrderStores from "./AdminPanel/components/VendorSection/AllHightOrderStores";
import AllHightRatedStores from "./AdminPanel/components/VendorSection/AllHightRatedStores";
import CreateVendor from "./AdminPanel/components/VendorSection/CreateVandor";

import Header from "./AdminPanel/Partials/Header/Header";
import Sidebar from "./AdminPanel/Partials/Sidebar/Sidebar";
import loader from "./assets/loader.gif";
import Test from "./Test";

const Home = React.lazy(() => import("./AdminPanel/components/Home/Home"));
const BannerFooter = React.lazy(() =>
  import("./AdminPanel/components/SiteSettings/BannerFooter")
);
const FlagshipStore = React.lazy(() =>
  import("./AdminPanel/components/SiteSettings/FlagshipStore")
);
const Coupons = React.lazy(() =>
  import("./AdminPanel/components/SiteSettings/Coupons")
);
const Category = React.lazy(() =>
  import("./AdminPanel/components/Categories/Category")
);

const Brands = React.lazy(() =>
  import("./AdminPanel/components/SiteSettings/Brands")
);

const Attributes = React.lazy(() =>
  import("./AdminPanel/components/SiteSettings/Attributes")
);

const MyProfile = React.lazy(() =>
  import("./AdminPanel/components/MyProfile/PersonalDetails")
);
const ForgetPass = React.lazy(() =>
  import("./AdminPanel/components/UserAuth/ForgetPass/ForgetPass")
);

const Login = React.lazy(() =>
  import("./AdminPanel/components/UserAuth/Login/Login")
);
const ResetPass = React.lazy(() =>
  import("./AdminPanel/components/UserAuth/ResetPass/ResetPass")
);

const VendorOverview = React.lazy(() =>
  import("./AdminPanel/components/VendorSection/Overview")
);
const Approvals = React.lazy(() =>
  import("./AdminPanel/components/VendorSection/Approvals")
);

const Notifly = React.lazy(() =>
  import("./AdminPanel/components/VendorSection/Notifly")
);

const MyDashboard = React.lazy(() =>
  import("./AdminPanel/components/VendorSection/MyDashboard")
);

const VendorList = React.lazy(() =>
  import("./AdminPanel/components/VendorSection/VendorList")
);

const UserOverview = React.lazy(() =>
  import("./AdminPanel/components/UsersSection/UserOverview")
);

const SubscriptionInfo = React.lazy(() =>
  import("./AdminPanel/components/UsersSection/SubscriptionInfo")
);

const UserList = React.lazy(() =>
  import("./AdminPanel/components/UsersSection/UserList")
);

const NotifyAllUsers = React.lazy(() =>
  import("./AdminPanel/components/UsersSection/NotifyAllUsers")
);

const ProductOverview = React.lazy(() =>
  import("./AdminPanel/components/ProductSection/ProductOverview")
);

const ProductList = React.lazy(() =>
  import("./AdminPanel/components/ProductSection/ProductList")
);

const TwoStarProduct = React.lazy(() =>
  import("./AdminPanel/components/ProductSection/TwoStarProduct")
);

const AddManagement = React.lazy(() =>
  import("./AdminPanel/components/AddManagement/AddManagement")
);

const DeliveryMan = React.lazy(() =>
  import("./AdminPanel/components/DeliveryMan/DeliveryMan")
);

const OrderSection = React.lazy(() =>
  import("./AdminPanel/components/OrderSection/OrderSection")
);

const AllPickup = React.lazy(() =>
  import("./AdminPanel/components/PickupStore/AllPickup")
);
const PickupStore = React.lazy(() =>
  import("./AdminPanel/components/PickupStore/PickupStoreOverview")
);

const Error = React.lazy(() => import("./AdminPanel/components/blank/Error"));

export default function AllRoutes() {
  let token = Cookies.get("access_token");
  return (
    <BrowserRouter>
      <div className="bg-[#f8fafb]">
        {token && <Sidebar />}

        <div className={token && "md:pl-64 flex flex-col flex-1"}>
          {token && <Header />}
          <main className="flex-1   h-full w-full ">
            <Routes>
              <Route
                exact
                path="/"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <Home />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/settings"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <PrivacyPassword />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/banner-footer"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <BannerFooter />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/brands"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <Brands />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/attribute"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <Attributes />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/category"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <Category />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/flagship-store"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <FlagshipStore />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/coupons"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <Coupons />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/my-profile"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <MyProfile />
                  </React.Suspense>
                }
              />
              <Route
                exact
                path="/vendor"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <VendorOverview />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/approvals"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <Approvals />
                  </React.Suspense>
                }
              />
              <Route
                exact
                path="/vendor-list"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <VendorList />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/notify"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <Notifly />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/my-dashboard"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <MyDashboard />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/vendor/all-rated-stores"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <AllHightRatedStores />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/vendor/all-orders-stores"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <AllHightOrderStores />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/vendor/create-vendor"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <CreateVendor />
                  </React.Suspense>
                }
              />
              <Route
                exact
                path="/users"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <UserOverview />
                  </React.Suspense>
                }
              />
              <Route
                exact
                path="/subscription"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <SubscriptionInfo />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/users-list"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <UserList />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/users/new-customers"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <AllNewCustomer />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/users/top-customers"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <AllTopCustomers />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/users/mostspent-customers"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <AllMostSpentCustomers />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/users-notify"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <NotifyAllUsers />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/products"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <ProductOverview />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/product-list"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <ProductList />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/star-products"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <TwoStarProduct />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/add-management"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <AddManagement />
                  </React.Suspense>
                }
              />
              <Route
                exact
                path="/orders"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <OrderSection />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/delivery-man"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <DeliveryMan />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/pickup-store"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <PickupStore />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/all-pickup"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <AllPickup />
                  </React.Suspense>
                }
              />

              <Route
                exact
                path="/chats"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <Chats />
                  </React.Suspense>
                }
              />
              <Route
                exact
                path="/test"
                element={
                  <React.Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full w-full">
                        <img
                          className="h-72 w-auto object-contain "
                          src={loader}
                          alt="loader"
                        />
                      </div>
                    }
                  >
                    <Test />
                  </React.Suspense>
                }
              />
            </Routes>
          </main>
        </div>

        <Routes>
          <Route
            exact
            path="/login"
            element={
              <React.Suspense
                fallback={
                  <div className="flex justify-center items-center h-full w-full">
                    <img
                      className="h-72 w-auto object-contain "
                      src={loader}
                      alt="loader"
                    />
                  </div>
                }
              >
                <Login />
              </React.Suspense>
            }
          />

          <Route
            exact
            path="/forget-password"
            element={
              <React.Suspense
                fallback={
                  <div className="flex justify-center items-center h-full w-full">
                    <img
                      className="h-72 w-auto object-contain "
                      src={loader}
                      alt="loader"
                    />
                  </div>
                }
              >
                <ForgetPass />
              </React.Suspense>
            }
          />

          <Route
            exact
            path="/reset-password"
            element={
              <React.Suspense
                fallback={
                  <div className="flex justify-center items-center h-full w-full">
                    <img
                      className="h-72 w-auto object-contain "
                      src={loader}
                      alt="loader"
                    />
                  </div>
                }
              >
                <ResetPass />
              </React.Suspense>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
